import { Box, Typography, Paper } from '@mui/material';
import type { ReactNode } from 'react';

interface OnboardingStepProps {
  icon: ReactNode;
  title: string;
  description: string;
  stepNumber: number;
}

export const OnboardingStep = ({ icon, title, description, stepNumber }: OnboardingStepProps) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 4,
        },
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          fontSize: '2rem',
        }}
      >
        {icon}
      </Box>
      
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: 'primary.light',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          fontWeight: 'bold',
        }}
      >
        {stepNumber}
      </Box>

      <Typography variant="h6" gutterBottom fontWeight="bold">
        {title}
      </Typography>
      
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Paper>
  );
};
